import { createAsyncThunk } from '@reduxjs/toolkit'
import { BomItemController } from 'controllers/Project/BomItemController'
import { ShowException } from 'store/Application/appActions'
import { getContext } from 'store/getContext'

export const downloadBomItemFiles = createAsyncThunk<any, any, { state: any }>(
  'BoM/download-bom-item-files',
  async (
    {
      bomItemId,
      bomItemType,
    }: { bomItemId: string; bomItemType: 'row' | 'project' | 'assembly' },
    thunkAPI
  ) => {
    const { projectId, partyId } = getContext(thunkAPI.getState)
    const bomItemController = new BomItemController(partyId, projectId)

    try {
      return await bomItemController.downloadBomItemFiles(
        bomItemId,
        bomItemType
      )
    } catch (err) {
      ShowException('download', err)
      return thunkAPI.rejectWithValue(err)
    }
  }
)
